import React from 'react';
import PropTypes from 'prop-types';

import { FAQ } from 'components/core/FAQ';
import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';

import './PSPFAQ.scss';

export default function PSPFAQ({ content, noHeader, type, faqSchema }) {
	return (
		<PSPModuleWrapper>
			<FAQ
				className="psp-faq"
				content={content}
				noHeader={noHeader}
				type={type}
				faqSchema={faqSchema}
			/>
		</PSPModuleWrapper>
	);
}

PSPFAQ.propTypes = {
	content: PropTypes.arrayOf(PropTypes.object).isRequired,
	noHeader: PropTypes.bool,
	type: PropTypes.string,
	faqSchema: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
